import LaunchAppUI from '../index';
import { LaunchAppControl } from '../../control';
import { getDomTree, updateDomTree } from './dom-tree';
import { trackEvent } from '../../utils/common';
import { onPageHideOnce, onPageShowOnce } from '../../onpage';
class LaunchHandler extends LaunchAppControl {
    constructor({ launchAppOptions }) {
        super(launchAppOptions);
        this.timer = null;
        this.waitTime = 0;
        this.visitTime = +new Date();
        this.inFocus = true;
        this.isClickInvokeApp = false;
        this.viewInstance = null;
        const { launchAppConfig, strategyData } = launchAppOptions;
        const { pullFailDeepLinks, pullDescription, pullFailMsg } = strategyData;
        this.launchAppConfig = launchAppConfig;
        this.pullDescription = pullDescription || '正在为您打开';
        this.pullFailMsg = pullFailMsg || '更多独享优惠等待发现中～';
        this.pullFailDeepLinks = pullFailDeepLinks;
        const pullFailItem = pullFailDeepLinks[0] || {};
        this.waitTime = pullFailItem.waitTime;
        onPageShowOnce(() => {
            this.inFocus = true;
        });
        onPageHideOnce(() => {
            this.inFocus = false;
            this.clearTimer();
        });
        // window.addEventListener('focus', () => {
        //   this.inFocus = true
        // })
        // window.addEventListener('blur', () => {
        //   this.inFocus = false
        // })
    }
    getVisitTime() {
        return this.visitTime;
    }
    getPageInFocus() {
        return this.inFocus;
    }
    createLaunchAppView() {
        const vDom = getDomTree.call(this);
        this.viewInstance = new LaunchAppUI();
        this.viewInstance.createUI(vDom, document.body);
        trackEvent('launch_app_force_pull_popup_expose');
    }
    removeLaunchAppView() {
        this.clearTimer();
        this.viewInstance?.removeUI('rootView');
    }
    // 自动拉端
    autoLaunchApp() {
        this.timer = setTimeout(() => {
            // 清除定时器
            this.clearTimer();
            if (!this.isClickInvokeApp) {
                // 自动拉端
                this.handleLaunch(this.pullFailDeepLinks[0]);
                const { linkType, cmd, extraParam } = this.pullFailDeepLinks[0];
                const trackParams = linkType === 4 ? { cmd, cmd_id: extraParam?.cmdId } : {};
                trackEvent('launch_app_download_btn_click', trackParams);
            }
        }, 2000);
    }
    // 是否支持微信开放标签
    isSupportWeixinTag(linkObj) {
        const { isUseWeixinTag } = this.launchAppConfig;
        return linkObj?.linkType === 8 && isUseWeixinTag && window?.wx;
    }
    // 清除定时器
    clearTimer() {
        clearTimeout(this.timer);
        this.timer = null;
    }
}
let launchHandler = null;
const showLaunchAppView = (launchAppOptions) => new Promise((resolve, reject) => {
    if (launchHandler) {
        launchHandler.removeLaunchAppView();
        launchHandler = null;
    }
    launchHandler = new LaunchHandler({ launchAppOptions });
    const { isAutoInvokeApp, isHideLaunchAppView } = launchHandler.launchAppConfig;
    const linkObj = launchHandler.pullFailDeepLinks[0] || {};
    if (Object.keys(linkObj).length === 0) {
        return reject();
    }
    const userWeixinTag = launchHandler.isSupportWeixinTag(linkObj);
    if (!isAutoInvokeApp || !isHideLaunchAppView || userWeixinTag)
        launchHandler.createLaunchAppView();
    if (+new Date() - launchHandler.getVisitTime() < 6000 && launchHandler.getPageInFocus()) {
        if (!isAutoInvokeApp || !isHideLaunchAppView || userWeixinTag)
            updateDomTree.call(launchHandler);
        if (isAutoInvokeApp && !userWeixinTag) {
            launchHandler.autoLaunchApp();
        }
        reject();
    }
    else {
        launchHandler.removeLaunchAppView(); // TODO：部分安卓手机会将系统弹窗识别为页面隐藏，为了防止误判拉端成功拉端成功后不移除弹窗
        resolve();
    }
});
export default showLaunchAppView;
